export default "__VITE_ASSET__3b5c5136__"